export default "__VITE_ASSET__96936f84__"